<template>
  <v-container fluid class="home p-0" v-if="homePage">
    <vue-headful :title="$t('header.home') + $t('title')"></vue-headful>
    <v-row class="m-0">
      <v-col class="position-relative p-0">
        <div class="banner" :style="'height:' + (pageWidth>1800?(pageWidth/28):pageWidth>1600?(pageWidth/26):pageWidth>1400?(pageWidth/24):pageWidth>1200?(pageWidth/22):(pageWidth/61 + 30)) +'vh'"></div>
        <div class="banner-description-container">
          <div class="desc-content">
            <v-icon dark class="banner-description-icon" size="30">mdi-cards-diamond</v-icon>
            <v-row class="banner-description-category font-size-40 text-center">
              <v-col v-html="$t('pre_reg.text_1')"></v-col>
            </v-row>
            <v-row class="banner-description-title font-size-100 text-center">
              <v-col v-html="$t('pre_reg.text_2')"></v-col>
            </v-row>
            <v-row v-if="!isLoggedIn" class="banner-description-description font-size-45 text-center">
              <v-col v-html="$t('pre_reg.text_3')"></v-col>
            </v-row>
            <v-row v-if="!isLoggedIn" class="banner-description-button">
              <v-col class="text-center">
                <v-btn rounded
                       color="white"
                       @click="$router.push({name:'register'})">
                  {{ $t('pre_reg.join_now') }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
        <!-- <div :class="['banner-description', {'ie-banner-description': isIE}]">
            <v-icon dark class="banner-description-icon">mdi-cards-diamond</v-icon>
            <v-row class="banner-description-category font-size-40 text-center text-transform-wide">
                <v-col v-html="$t('pre_reg.text_1')"></v-col>
            </v-row>
            <v-row class="banner-description-title font-size-100 text-center text-transform-wide">
                <v-col v-html="$t('pre_reg.text_2')"></v-col>
            </v-row>
            <v-row class="banner-description-description font-size-45 text-center">
                <v-col v-html="$t('pre_reg.text_3')"></v-col>
            </v-row>
            <v-row>
                <v-col class="text-center">
                    <v-btn rounded
                           color="white"
                           @click="$router.push({name:'register'})">
                        {{$t('pre_reg.join_now')}}
                    </v-btn>
                </v-col>
            </v-row>
        </div> -->
      </v-col>
    </v-row>
    <v-row class="hot-items hidden-sm-and-down m-0">
      <!--      <v-spacer v-if="$vuetify.breakpoint.width >= 1200"></v-spacer>-->
      <v-col class="hot-item-wrapper">
        <div class="hot-item-label">
          <span class="hot-item-text">{{ $t('home.hot_items') }}</span>
          <div class="hot-item-arrow"/>
        </div>
        <!-- <b-row class="fill-height">
            <b-col>
                <v-btn block
                       text
                       color="primary"
                       style="height: 100% !important;">
                    {{$t('home.hot_items')}}
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </b-col>
        </b-row> -->
      </v-col>
      <v-col v-for="item in homePage.hot_items"
             class="hot-item-wrapper hot-item animation-ease"
             @click="$router.push({name: 'facility', params: {facilityTypeId: item.id}})">
        <v-row class="text-center">
          <v-col class="text-center pb-0">
            <div class="hot-item-img"
                 :style="{'background-image': 'url(\'' + host + 'static/' + item.icon + '\')'}"></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="hot-item-label">
            {{ $localeGet(item, 'name') }}
          </v-col>
        </v-row>
      </v-col>


      <v-col v-if="homePage && homePage.hot_items.length === 0"
             class="hot-item-wrapper hot-item animation-ease"
             @click="$router.push({name: 'promotion'})">
        <v-row class="text-center">
          <v-col class="text-center pb-0">
            <div class="hot-item-img special-offer"></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="hot-item-label">
            {{ $t('promotion.title') }}
          </v-col>
        </v-row>
      </v-col>
      <v-col v-if="homePage && homePage.hot_items.length === 0"
             class="hot-item-wrapper hot-item animation-ease"
             @click="toggleMenuFacility">
        <v-row class="text-center">
          <v-col class="text-center pb-0">
            <div class="hot-item-img facilities"></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="hot-item-label">
            {{ $t('header.facility') }}
          </v-col>
        </v-row>
      </v-col>
      <v-col v-if="homePage && homePage.hot_items.length === 0"
             class="hot-item-wrapper hot-item animation-ease"
             @click="toggleMenuEvent">
        <v-row class="text-center">
          <v-col class="text-center pb-0">
            <div class="hot-item-img events"></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="hot-item-label">
            {{ $t('header.event') }}
          </v-col>
        </v-row>
      </v-col>

      <v-col class="gym-availability-wrapper animation-ease"
             @click="reserveGym">
        <v-row class="gym-availability-label text-left">
          <v-col>
            <v-row class="gym-availability-text gym-availability-date mb-2">{{ $parseDate(new Date().toISOString(), 'yyyy-MM-dd') }}</v-row>
            <v-row class="gym-availability-text">{{ $t('gym_booking.status') }}</v-row>
          </v-col>
          <div class="gym-availability-arrow"/>
        </v-row>
      </v-col>
      <v-col class="gym-availability-wrapper hoverable animation-ease"
             @click="reserveGym">
        <div class="gym-availability-label">
          <span class="gym-availability-count-label">{{ $t('gym_booking.availability') }}</span>
          <span class="gym-availability-count">{{ gymBookingAvailableCount }}<span class="max-count">/{{ gymBookingMaxCount }}</span></span>
        </div>
      </v-col>
      <!--      <v-spacer v-if="$vuetify.breakpoint.width >= 1200"></v-spacer>-->
    </v-row>
    <!--Mobile Gym Availability-->
    <v-row class="hot-items mobile-gym hidden-md-and-up m-0"
    >
      <v-col class="gym-availability-wrapper animation-ease">
        <v-row class="gym-availability-label text-left pl-6">
          <v-col>
            <v-row class="gym-availability-text gym-availability-date mb-2">{{ $parseDate(new Date().toISOString(), 'yyyy-MM-dd') }}</v-row>
            <v-row class="gym-availability-text">{{ $t('gym_booking.status') }}</v-row>
          </v-col>
          <div class="gym-availability-arrow"/>
        </v-row>
      </v-col>
      <v-col class="gym-availability-wrapper hoverable animation-ease"
             @click="reserveGym">
        <div class="gym-availability-label">
          <span class="gym-availability-count-label">{{ $t('gym_booking.availability') }}</span>
          <span class="gym-availability-count">{{ gymBookingAvailableCount }}<span class="max-count">/{{ gymBookingMaxCount }}</span></span>
        </div>
      </v-col>
    </v-row>
    <HkiaraceCardDisplayFrame
        class="about-acc"
        image-class="about-acc-image"
        image-min-height="60vh"
        :page-width="pageWidth"
        :is-static-info-card="true"
    >
      <template slot="sub-title">
        {{ $t('home.description_title') }}
      </template>
      <template slot="title">
        {{ $t('home.description_sub_title') }}
      </template>
      <template slot="content">
        <div class="about-acc-desc-content">
          {{ $t('home.description_content') }}
        </div>
        <div>
          <v-btn class="function-button" color="primary" rounded :to="{name: 'about'}">
            {{ $t('about_acc.learn_more') }}
          </v-btn>
        </div>
      </template>
    </HkiaraceCardDisplayFrame>

    <v-row class="home-facility" :style="pageWidth<1200?'margin:1rem':''" dense :no-gutters="pageWidth > 1200" v-if="facilityTypes">
      <v-col :cols="pageWidth<1200?12:4">
        <div class="facility-label font-size-70">
          {{ $t('header.facility') }}
        </div>
        <!-- <v-btn text block color="primary"
               style="height: 100% !important;">{{$t('header.facility')}}
        </v-btn> -->
      </v-col>
      <v-col v-for="f in pageWidth<1200?mobileShowingFacilities:showingFacilities"
             :key="f.id"
             :cols="pageWidth<1200?6:f.long?4:2">
        <!--:md="f.long ? 4 : 2">-->
        <router-link :to="{ name: 'facility', params: {facilityTypeId: f.id }}">
          <div :class="['home-facility-item', {'facility-long': f.long}]" :style="getFacilityBackground(f)">
            <div v-if="!f.group || pageWidth < 1200" class="home-facility-item-label p-1 px-md-4 py-md-2 text-right">
              <div v-if="f.group === 'H'">{{ $t('header.facilityHall') }}</div>
              <div v-if="f.group === 'R'">{{ $t('header.facilityRoom') }}</div>
              {{ facilityTypes[f.id].name }}
            </div>
          </div>
        </router-link>
      </v-col>
      <v-col :cols="pageWidth<1200?6:2">
        <v-btn block
               text
               color="primary"
               style="height: 100% !important;"
               @click="toggleMenuFacility"
        >
          <div class="more-button-content title-font">
                        <span class="icon">
                            +
                        </span>
            <span class="text">
                            {{ $t('home.more_facility') }}
                        </span>
          </div>
        </v-btn>
      </v-col>
      <!-- Desktop Label Container -->
      <v-row v-if="pageWidth >= 1200" class="home-facility-label-container" :style="pageWidth<1200?'margin:1rem':''" :no-gutters="pageWidth > 1200">
        <v-col md="4" offset-md="8" style="bottom: 50%">
          <div class="home-facility-item facility-long">
            <div class="home-facility-item-label p-1 px-md-4 py-md-2">
              <div class="home-facility-item-label-title">{{ $t('header.facilityHall') }}</div>
              {{ facilityTypes['bd3c8a53-dad3-4f27-bf58-4bd8c40912a1'].name }} / {{ facilityTypes['9a8cdd8d-f90d-4ca3-b8b4-0c2b7cd1cb02'].name }}
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="pageWidth >= 1200" class="home-facility-label-container" :style="pageWidth<1200?'margin:1rem':''" :no-gutters="pageWidth > 1200">
        <v-col md="4" offset-md="6" style="bottom: 0%">
          <div class="home-facility-item facility-long">
            <div class="home-facility-item-label p-1 px-md-4 py-md-2">
              <div class="home-facility-item-label-title">{{ $t('header.facilityRoom') }}</div>
              {{ facilityTypes['ccc98a25-50c3-4def-9b31-c6e249c0e156'].name }} / {{ facilityTypes['dc332b1a-dc3d-43d4-9d98-7c35e209c869'].name }}
            </div>
          </div>
        </v-col>
      </v-row>
    </v-row>

    <v-row class="m-0">
      <v-col class="home-upcoming-events py-10" cols="12" md="6" :style="{padding: 0}">
        <b-col sm="12" offset-sm="0" md="10" offset-md="2" :style="{padding: '0 20px'}">
          <v-row class="mx-2">
            <div class="upcoming-event-title text-left">{{ $t('home.upcoming_event') }}</div>
          </v-row>
          <v-row class="mx-2">
            <v-divider></v-divider>
          </v-row>
          <v-row v-for="(event, index) in upcomingEvents"
                 class="upcoming-event-item mx-2">
            <v-col cols="4" class="d-flex align-center">
              <div :style="getUpcomingEventStyle(event)"
                   class="upcoming-event-item-image"/>
            </v-col>
            <v-col cols="8" class="d-flex align-center">
              <router-link :to="{name: 'event-list', params: {categoryId: event.category.id}}">
                <div class="text-left upcoming-event-item-date">
                  {{ event.date }}
                </div>
                <div class="text-left upcoming-event-item-title" v-html="$localeGet(event, 'name')">
                </div>
                <div class="text-left upcoming-event-item-description" v-html="$localeGet(event, 'description')">
                </div>
              </router-link>
            </v-col>
          </v-row>
          <v-row class="mx-2 text-left">
            <v-col>
              <v-btn class="function-button" rounded color="primary" @click="toggleMenuEvent">
                {{ $t('home.more_events') }}
              </v-btn>
            </v-col>
          </v-row>
        </b-col>
      </v-col>
      <v-col class="home-promotions py-10" cols="12" md="6" :style="{padding: 0}">
        <b-col sm="12" md="10" :style="{padding: '0 20px'}">
          <v-row class="mx-2">
            <div class="promotion-title text-left">{{ $t('promotion.title') }}</div>
          </v-row>
          <v-row class="mx-2">
            <v-divider></v-divider>
          </v-row>
          <v-row class="mx-2 m-0">
            <v-col v-for="promotion in promotions"
                   cols="6" sm="3"
                   class="promotion-item">
              <div :style="getPromotionStyle(promotion)"
                   @click="showPromotionContent(promotion)"
                   class="promotion-item-icon"></div>
            </v-col>
          </v-row>
        </b-col>
      </v-col>
    </v-row>

    <v-dialog
        v-model="bannerShowDialog"
        content-class="popup_dialog"
        overlay-color="#ffffff"
        overlay-opacity="0.85"
    >
      <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->

      <v-carousel :height="$vuetify.breakpoint.height*0.6" cycle :interval="3000" hide-delimiters class="popup_bg" :show-arrows="false">
        <v-carousel-item v-for="b in banners"
                         :key="b.id"
                         :src="'/api/static/' + b.banner"
                         reverse-transition="fade-transition"
                         transition="fade-transition"
                         :href="b.link"
                         contain
        ></v-carousel-item>
        <div class="popup_close_btn" @click="bannerShowDialog = false">
          <font-awesome-icon class="popup_close_icon" icon="times-circle" :size="(parseInt((pageWidth/900))+2) + 'x'" fixed-width></font-awesome-icon>
        </div>
      </v-carousel>
    </v-dialog>
  </v-container>
</template>

<script>

import {HOST} from '@/main'
import HkiaraceCardDisplayFrame from '../../components/HkiaraceCardDisplayFrame'
import {library} from '@fortawesome/fontawesome-svg-core';
import {faPlayCircle, faTimesCircle} from '@fortawesome/free-solid-svg-icons';
import {computed, onMounted, ref} from "@vue/composition-api";
import HomeBanner from "@/views/client/HomeBanner";

library.add(faPlayCircle, faTimesCircle);


export default {
  name: 'Home',
  components: {
    HkiaraceCardDisplayFrame
  },
  setup(props, {root, emit}) {
    const pageWidth = ref(window.innerWidth);
    const isLoggedIn = computed(() => !!root.$store.state.user.id);
    const isIE = computed(() => {
      let userAgent = window.navigator.userAgent;
      var msie = userAgent.indexOf("MSIE ");

      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
      {
        return true;
      } else {
        return false;
      }
    })

    const homePage = ref(null);
    const upcomingEvents = ref([]);
    const getUpcomingEventStyle = function (e) {
      let images = JSON.parse(e.images);
      return {
        'background-image': `url('${HOST}static/` + images[0] + "')",
      }
    }
    const banners = ref([]);
    const getHomePage = function () {
      root.$callAPI('hkiarace/', {}, function (response) {
        homePage.value = response.body;
        upcomingEvents.value = response.body.banner_events ? response.body.banner_events.slice(0, 2) : [];
        banners.value = response.body.banners.filter((banner) => {
          let today = new Date()
          if (!banner.deleted_at && new Date(banner.from_time) <= today && today <= new Date(banner.to_time)) {
            return true
          }

          return false
        });

        if (banners.value.length > 0) {
          // bannerShowDialog.value = true
          // root.$showBanners(banners.value);
        }
      })
    }

    const promotions = ref([]);
    const getPromotions = function () {
      root.$callAPI('hkiarace/promotion/', {}, function (response) {
        promotions.value = response.body.promotions;
      });
    }
    const getPromotionStyle = function (promotion) {
      return {
        'background-image': `url('${HOST}static/` + promotion.icon + "')",
        'background-size': '80%',
        'background-position': 'center',
        'background-repeat': 'no-repeat'
      }
    }
    const showPromotionContent = function (promotion) {
      window.open('api/static/' + promotion.content, '_blank');
    }

    const events = ref([]);
    const slideShowDialog = ref(false);
    const loadSlideShow = function () {
      root.$callAPI('hkiarace/event/past/', {page_size: 12, page_no: 0}, function (response) {
        events.value = response.body.events.map((e) => ({id: e.id, image: '/api/static/' + e.memorable_moment_cover_id, link: e.link}));
      }, null, true);
    }
    const showSlideShow = function () {
      slideShowDialog.value = true;
    };

    const bannerShowDialog = ref(false);

    const facilityTypes = ref(null);
    const getFacilityTypes = function () {
      root.$callAPI('aafb/facility_types/', {}, function (response) {
        let map = {};

        response.body.item_types.forEach((a) => {
          map[a.id] = a;
        });

        facilityTypes.value = map;
      });
    }
    const getFacilityBackground = function (f) {
      return {
        'background-image': "url('" + f.image + "')",
      }
    }
    const toggleMenuFacility = function () {
      emit('toggleMenuFacility');
    }
    const toggleMenuEvent = function () {
      emit('toggleMenuEvent')
    }

    const showingFacilities = ref([
      {id: 'b1eec08f-2cc5-4cc6-8eeb-cc42c6ce6b0e', long: false, image: require('../../assets/home_sleeping.jpg')}, // Sleeping Pod
      {id: 'bd3c8a53-dad3-4f27-bf58-4bd8c40912a1', long: true, image: require('../../assets/home_basketball.jpg'), group: 'H'}, // Basketball
      {id: '9a8cdd8d-f90d-4ca3-b8b4-0c2b7cd1cb02', long: false, image: require('../../assets/home_badminton.jpg'), group: 'H'}, // Badminton
      {id: '84d5f15f-2f7e-46d9-9ff3-fa5c29d8f386', long: false, image: require('../../assets/home_bbq.jpg')}, // BBQ Site
      {id: '52739c69-e0e4-4be5-a155-0160a1fbcb6e', long: true, image: require('../../assets/home_gym.jpg')}, // Gym Room
      {id: 'ccc98a25-50c3-4def-9b31-c6e249c0e156', long: false, image: require('../../assets/home_yoga.jpg'), group: 'R'}, // Event Venue
      {id: 'dc332b1a-dc3d-43d4-9d98-7c35e209c869', long: false, image: require('../../assets/home_tabletennis.jpg'), group: 'R'}, // Table Tennis
    ]);
    const mobileShowingFacilities = ref([
      {id: '52739c69-e0e4-4be5-a155-0160a1fbcb6e', long: true, image: require('../../assets/home_gym.jpg')}, // Gym Room
      {id: '84d5f15f-2f7e-46d9-9ff3-fa5c29d8f386', long: false, image: require('../../assets/home_bbq.jpg')}, // BBQ Site
      {id: 'bd3c8a53-dad3-4f27-bf58-4bd8c40912a1', long: true, image: require('../../assets/home_basketball.jpg'), group: 'H'}, // Basketball
      {id: '9a8cdd8d-f90d-4ca3-b8b4-0c2b7cd1cb02', long: false, image: require('../../assets/home_badminton.jpg'), group: 'H'}, // Badminton
      {id: 'dc332b1a-dc3d-43d4-9d98-7c35e209c869', long: false, image: require('../../assets/home_tabletennis.jpg'), group: 'R'}, // Table Tennis
      {id: 'ccc98a25-50c3-4def-9b31-c6e249c0e156', long: false, image: require('../../assets/home_yoga.jpg'), group: 'R'}, // Event Venue
      {id: 'b1eec08f-2cc5-4cc6-8eeb-cc42c6ce6b0e', long: false, image: require('../../assets/home_sleeping.jpg')}, // Sleeping Pod
    ]);

    const gymBookingAvailableCount = ref(0);
    const gymBookingMaxCount = ref(1);
    const getGymBookingStatus = function () {
      root.$callAPI('aafb/gym_booking/status/', {today: true}, (response) => {
        gymBookingMaxCount.value = response.body.max;
        gymBookingAvailableCount.value = gymBookingMaxCount.value - (response.body.counts.length > 0 ? response.body.counts[0].count : 0) + response.body.today_offset;
      });
    }
    const reserveGym = function () {
      root.$router.push({name: 'facility', params: {facilityTypeId: '52739c69-e0e4-4be5-a155-0160a1fbcb6e'}})
    };

    onMounted(async () => {
      getHomePage();
      getPromotions();
      loadSlideShow();
      getFacilityTypes();
      getGymBookingStatus();
      root.$nextTick(() => {
        window.addEventListener('resize', () => {
          pageWidth.value = window.innerWidth;
        });
      });

      // await root.$dialog.showAndWait(HomeBanner, {})
    })

    return {
      pageWidth,
      isLoggedIn,
      isIE,

      homePage,
      upcomingEvents,
      getUpcomingEventStyle,
      banners,

      promotions,
      getPromotionStyle,
      showPromotionContent,

      events,
      slideShowDialog,
      showSlideShow,
      bannerShowDialog,

      facilityTypes,
      getFacilityBackground,
      toggleMenuFacility,
      toggleMenuEvent,

      showingFacilities,
      mobileShowingFacilities,

      gymBookingAvailableCount,
      gymBookingMaxCount,
      reserveGym,

      host: HOST,
    }
  },
}
</script>

<style lang="less">
.home {
  .banner {
    background-image: url('../../assets/acc.jpg');
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;

    width: 100%;
    // padding-top: 48%;
    height: 40vh;
    overflow: hidden;
  }

  .banner-description-container {
    width: 100%;
    display: flex;
    color: white;
    font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;

    .desc-content {
      background-color: rgba(157, 127, 95, 1);
      width: 100%;
      padding: 0% 5% 2% 5%;
    }

    .banner-description-icon {
      /*margin-top: -10.5%;*/
      display: none;
      top: 0.75%;
      position: absolute;
      left: 0;
      transform: translateY(-50%);
    }

    .banner-description-category {
      font-size: 0.9rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin-top: 12px;
      line-height: 1.2;
    }

    .banner-description-title {
      font-weight: 400;
      font-size: 1.8rem;
      color: rgba(255, 255, 255, 1);
      line-height: 1.1;
    }

    .banner-description-description {
      font-family: Roboto, "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
      color: rgba(255, 255, 255, 1);
      margin: 1% 0%;
      font-size: 0.85rem;
      overflow: visible;
    }

    .banner-description-button {
      font-family: Roboto, "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;

      .v-btn {
      }

      .v-btn__content {
        color: rgba(157, 127, 95, 0.8);
        margin: 0.5rem 1rem;
      }
    }

    @media only screen and (min-width: 1200px) {
      position: absolute;
      bottom: 0;
      width: 50% !important;
      justify-content: flex-end;

      .banner-description-category {
        font-size: 1.2rem;
        margin-top: 8px;
        line-height: 1.1;
      }

      .banner-description-title {
        font-size: 2.4rem;
        color: rgba(255, 255, 255, 1);
        line-height: 1.2;
      }

      .banner-description-description {
        font-size: 0.9rem;
        overflow: visible;
      }

      .banner-description-button {
        margin-top: 0.9rem;
        margin-bottom: 0.9rem;

        .v-btn {
          height: 2rem;
        }

        .v-btn__content {
          margin: 0.4rem 0.8rem;
        }
      }

      .desc-content {
        /*margin-right: 2.3% !important;*/
        width: 78.8% !important;
        position: relative;
        align-items: center;
        justify-content: center;
        background-color: rgba(156, 131, 98, 0.75) !important;
        padding: 2% 0% !important;
      }

      .banner-description-icon {
        width: 100%;
        display: flex !important;
        justify-content: center;
        /*transform: translateY(-170%);*/
      }
    }

    @media only screen and (min-width: 1600px) {
      position: absolute;
      bottom: 0;
      width: 50% !important;
      justify-content: flex-end;


      .banner-description-category {
        font-size: 1.4rem;
        margin-top: 12px;
        line-height: 1.2;
      }

      .banner-description-title {
        font-weight: 400;
        font-size: 2.8rem;
        line-height: 1.3;
      }

      .banner-description-description {
        font-size: 1rem;
        overflow: visible;
      }

      .banner-description-button {
        margin-top: 1.2rem;
        margin-bottom: 1.2rem;

        .v-btn {
          height: 3rem;
        }

        .v-btn__content {
          margin: 0.5rem 1rem;
        }
      }

      .desc-content {
        /*margin-right: 2.3% !important;*/
        width: 78.8% !important;
        position: relative;
        align-items: center;
        justify-content: center;
        background-color: rgba(156, 131, 98, 0.75) !important;
        padding: 5% 0% !important;
      }

      .banner-description-icon {
        width: 100%;
        display: flex !important;
        justify-content: center;
        /*transform: translateY(-170%);*/
      }
    }
  }

  .banner-description {
    height: auto !important;
    font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
    padding: 3% 5%;
    background-color: rgba(142, 118, 91, 1);
    box-shadow: 0 0 10px -5px;

    overflow: visible;
    line-height: 1.2;

    .banner-description-icon {
      display: none;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateY(-50%);
    }

    .banner-description-category {
      color: white;
    }

    .banner-description-title {
      color: white;
    }

    .banner-description-description {
      color: white;
      font-size: 1rem;
      overflow: visible;
    }
  }

  .hot-items {
    font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
    font-smooth: greyscale;

    & > :not(:first-child) {
      border-left: 1px solid rgb(232, 232, 232);
    }

    // .hot-item-wrapper:last-child {
    //     border-right: 1px solid rgb(232, 232, 232);
    // }

    .hot-item-wrapper {
      padding: 2.6rem;
      // border-left: 1px solid rgb(232, 232, 232);

      .hot-item-label {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: rgba(0, 0, 0, 0.9);
        text-transform: uppercase;

        .hot-item-text {
          color: rgba(142, 118, 91, 0.8);
          /*color: rgb(142, 118, 91);*/
          font-size: 1.3rem;
        }

        .gym-availability-text {
          text-align: left;
          font-size: 0.6rem;
        }

        .gym-availability-count {
          color: rgba(142, 118, 91, 0.8);
          /*color: rgb(142, 118, 91);*/
          font-size: 4rem;
        }

        .hot-item-arrow {
          margin-left: 1.3rem;
          width: 20px;
          height: 20px;
          position: relative;
          overflow: hidden;
          box-sizing: border-box;
        }

        .hot-item-arrow:before {
          content: "";
          position: absolute;
          top: 0;
          right: 75%;
          width: 100%;
          height: 100%;
          border: 1px solid rgba(0, 0, 0, 0.8);
          transform: rotate(45deg);
        }
      }
    }

    .hot-item {
      cursor: pointer;

      .hot-item-img {
        margin: auto;
        width: 50px;
        padding-top: 72px;

        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;

        &.special-offer {
          background-image: url('../../assets/hot_item_special_offer.png');
        }

        &.facilities {
          background-image: url('../../assets/hot_item_facilities.png');
        }

        &.events {
          background-image: url('../../assets/hot_item_events.png');
        }
      }

      .hot-item-label {
        font-size: 1rem;
      }

      &:hover {
        background-color: rgba(142, 118, 91, 0.04);
      }
    }

    .gym-availability-wrapper {
      padding: 2.6rem;

      .gym-availability-label {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: rgba(0, 0, 0, 0.9);
        text-transform: uppercase;

        .gym-availability-text {
          color: rgba(142, 118, 91, 0.8);
          /*color: rgb(142, 118, 91);*/
          font-size: 1.3rem;

          &.gym-availability-date {
            font-size: 0.8rem;
          }
        }

        .gym-availability-arrow {
          margin-left: 1.3rem;
          width: 20px;
          height: 20px;
          position: relative;
          overflow: hidden;
          box-sizing: border-box;
        }

        .gym-availability-arrow:before {
          content: "";
          position: absolute;
          top: 0;
          right: 75%;
          width: 100%;
          height: 100%;
          border: 1px solid rgba(0, 0, 0, 0.8);
          transform: rotate(45deg);
        }

        .gym-availability-count-label {
          text-align: left;
          font-size: 0.6rem;
        }

        .gym-availability-count {
          margin-left: 12px;
          color: rgba(142, 118, 91, 0.8);
          font-size: 4rem;

          .max-count {
            font-size: 0.7rem;
          }
        }
      }

      &.hoverable {
        cursor: pointer;

        &:hover {
          background-color: rgba(142, 118, 91, 0.04);
        }
      }
    }

    &.mobile-gym {
      .gym-availability-wrapper {
        padding: 1rem;

        .gym-availability-text {
          font-size: 1rem !important;
        }

        .gym-availability-date {

        }

        .gym-availability-text {
          font-size: 0.6rem;
        }

        .gym-availability-count {
          font-size: 3rem;
        }
      }
    }
  }

  .about-acc {
    background-color: rgba(239, 239, 239, 1);

    .about-acc-image {
      // width: 100%;
      // height: 100%;
      // padding-top: 66%;

      background-image: url('../../assets/aboutacc.jpg');
      // background-size: cover;
      // background-position: center;
      // background-repeat: no-repeat;
    }

    // .about-acc-description {
    //     background-color: rgba(239, 239, 239, 1);
    //     padding: 2rem 1rem;

    //     .desc-title {
    //         font-size: 0.9rem;
    //         font-family: 'Montserrat' !important;
    //     }

    //     .about-acc-sub-title {
    //         font-size: 2.0rem;
    //         /*font-weight: 300;*/
    //         letter-spacing: -2px;
    //         line-height: 1.2em;
    //         font-family: 'Montserrat' !important;
    //     }

    //     @media only screen and (min-width: 960px) {
    //         padding: 4rem 8rem 4rem 2rem !important;
    //     }

    //     @media only screen and (min-width: 1400px) {
    //         padding: 4rem 16rem 4rem 2rem !important;
    //     }


    //     .about-acc-description-content {
    //         padding: 0;

    //         .desc-title {
    //             /*letter-spacing: 0.5px;*/
    //             /*text-transform: uppercase;*/
    //         }

    //         .desc-content, .desc-title {
    //             font-size: 0.9rem;
    //             color: rgba(105, 103, 103, 0.8);
    //             line-height: 2em;
    //         }
    //     }
    // }
    .function-button {
      margin-top: 1.2rem;
      margin-bottom: 1.2rem;
      height: 3rem;

      .v-btn__content {
        font-size: 1.1rem;
        color: rgb(250, 250, 250);
        margin: 0.5rem 1rem;
      }
    }
  }


  .home-facility {
    position: relative;

    .home-facility-label-container {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      pointer-events: none;

      .home-facility-item-label {
        width: 100%;
        left: 0;
        max-width: 100% !important;
        text-align: left !important;
      }

      .home-facility-item-label-title {
        font-weight: 400;
        letter-spacing: 1.06pt;
        font-size: 1.4rem !important;
        text-transform: uppercase;
      }
    }

    .facility-label {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      text-transform: uppercase;
      font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
      letter-spacing: 1px;
      padding: 2rem 1rem 1rem 1rem;
      color: black;
    }

    .home-facility-item {
      position: relative;
      width: 100%;
      height: 100%;
      margin-bottom: 7%;
      padding-top: 100%;

      /*background-image: url('../../assets/acc.jpg');*/
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      &.facility-long {
        padding-top: 50% !important;
      }

      .home-facility-item-label {
        font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
        font-size: 1rem;
        font-weight: 500;
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: rgba(142, 118, 91, 0.8);
        color: rgba(255, 255, 255, 0.8);
        max-width: 75%;
      }
    }

    .more-button-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .icon {
        color: #000000;
        font-weight: 100;
        font-size: 60px;

        .v-icon {
          font-size: 30px;
        }
      }

      .text {
        color: rgb(113, 113, 113);
        text-transform: capitalize;
        letter-spacing: normal;
        font-weight: 400;
        font-size: 1rem;
      }
    }
  }

  .home-promotions {
    background-color: rgb(224, 216, 210);

    .promotion-title {
      // font-size: 2rem;
      // font-weight: bold;
      font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
      font-weight: 400;
      color: rgba(142, 118, 91, 1);
      text-transform: uppercase;
      letter-spacing: 1px;
      padding-bottom: 0.5rem;
      font-size: 2.25rem;


      @media only screen and (max-width: 1200px) {
        text-align: center !important;
        width: 100%;
        transform-origin: top center !important;
        font-size: 1.3rem;
      }
    }

    .v-divider {
      border-width: 0.5px;
      border-color: rgba(230, 230, 230, 0.8);
    }

    .promotion-item {
      padding: 0.3rem;

      .promotion-item-icon {
        cursor: pointer;
        width: 100%;
        padding-top: 100%;
        background-color: white;
      }
    }
  }

  .home-upcoming-events {
    .upcoming-event-title {
      // font-size: 2rem;
      // font-weight: bold;
      font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
      font-weight: 400;
      color: black;
      text-transform: uppercase;
      letter-spacing: 1px;
      padding-bottom: 0.5rem;
      font-size: 2.25rem;

      @media only screen and (max-width: 1200px) {
        text-align: center !important;
        width: 100%;
        transform-origin: top center !important;
        font-size: 1.3rem;
      }
    }

    .v-divider {
      border-width: 0.5px;
      border-color: rgba(220, 220, 220, 0.5);
    }

    .upcoming-event-item {
      .upcoming-event-item-image {
        width: 100%;
        padding-top: 100%;

        background-image: url('../../assets/acc.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      }

      .upcoming-event-item-date {
        font-size: 0.9rem;
        font-family: Roboto, "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
        color: rgb(160, 160, 160);
      }

      .upcoming-event-item-title {
        font-size: 1.3rem;
        font-family: Roboto, "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
        color: rgb(48, 48, 48);
      }

      .upcoming-event-item-description {
        font-size: 1.0rem;
        color: rgb(170, 170, 170);
      }

      @media only screen and (max-width: 1200px) {
        .upcoming-event-item-date {
          font-size: 0.8rem;
        }

        .upcoming-event-item-title {
          font-size: 1.0rem;
        }

        .upcoming-event-item-description {
          font-size: 0.9rem;
        }
      }
    }

    .function-button {
      font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
      margin-top: 1.2rem;
      margin-bottom: 1.2rem;
      height: 3rem;

      .v-btn__content {
        font-size: 1.0rem;
        font-weight: 400;
        color: rgb(250, 250, 250);
        margin: 0.5rem 1rem;
      }
    }
  }
}

@media only screen and (min-width: 700px) {
  .home-facility {
    .facility-label {
      padding: 2rem;
    }

    .home-facility-item {
      &.home-facility-long {
        padding-top: 0 !important;
      }

      .home-facility-item-label {
        font-size: 1.1rem !important;
      }
    }
  }
}

@media only screen and (min-width: 1200px) {
  .home {
    .banner {
      // padding-top: 40% !important;
      height: 90vh;
    }

    .banner-description {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-100%);
      background-color: rgba(142, 118, 91, 0.9) !important;

      .banner-description-icon {
        display: inline;
      }

      &.ie-banner-description {
        width: 40%;
      }
    }
  }

  .home-facility {
    .facility-label {
      padding: 4rem;
    }

    .home-facility-item {
      &.home-facility-long {
        padding-top: 0 !important;
      }

      .home-facility-item-label {
        font-size: 1.3rem !important;
      }
    }
  }
}


.popup_dialog {
  box-shadow: none;
  padding-left: 10vw;
  padding-right: 10vw;
}

.popup_bg {
  /*padding: 10vh;*/
  position: relative;
  background-color: rgba(255, 255, 255, 0);
  /*max-width: 600px;*/

  /*@media only screen and (min-width: 800px) {*/
  /*padding-left: 10vw;*/
  /*pading-right: 10vw;*/
  /*}*/

  /*@media only screen and (min-width: 1200px) {*/
  /*padding-left: 20vw;*/
  /*pading-right: 20vw;*/
  /*}*/
}

.popup_close_btn {
  position: absolute;
  right: 0%;
  top: 0%;
  /*padding: 10px;*/
  cursor: pointer !important;
}

.popup_close_icon {
  position: relative;
  color: rgba(100, 100, 100, .95);

  text-shadow: 2px 2px rgba(244, 244, 244, .75);
}
</style>
